import React, { useContext } from 'react';
import { ActualIconProps } from 'mobx/commonTypes';
import { useTheme } from '@mui/material/styles';
import { UiContext } from 'uiContext';
import { defaultSpacingPresets } from 'hooks/useGetSpacing';

export default function IconPowerRain({
  style,
  extColor,
  isAutoscallable = true,
  sizeKey = '32x32',
}: ActualIconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.customBackgrounds.contrast;
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      style={style}
      width={w}
      height={h}
      viewBox="0 0 32 32"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.84842 21.8998C6.62649 22.5113 6.93075 22.9092 7.42175 23.0882C7.91275 23.2672 8.40255 23.158 8.62627 22.5465C8.84821 21.935 8.51293 20.0933 8.51293 20.0933C8.51293 20.0933 7.07095 21.2883 6.84902 21.8998H6.84842Z"
        fill="white"
      />
      <path
        d="M11.7762 21.8998C11.5537 22.5113 11.8585 22.9092 12.3495 23.0882C12.8405 23.2672 13.3303 23.158 13.5541 22.5465C13.776 21.935 13.4407 20.0933 13.4407 20.0933C13.4407 20.0933 11.9987 21.2883 11.7768 21.8998H11.7762Z"
        fill="white"
      />
      <path
        d="M16.704 21.8998C16.4814 22.5113 16.7863 22.9092 17.2773 23.0882C17.7683 23.2672 18.2581 23.158 18.4818 22.5465C18.7037 21.935 18.3684 20.0933 18.3684 20.0933C18.3684 20.0933 16.9265 21.2883 16.7045 21.8998H16.704Z"
        fill="white"
      />
      <path
        d="M21.6317 21.8998C21.4092 22.5113 21.7141 22.9092 22.2051 23.0882C22.6961 23.2672 23.1859 23.158 23.4096 22.5465C23.6315 21.935 23.2962 20.0933 23.2962 20.0933C23.2962 20.0933 21.8543 21.2883 21.6323 21.8998H21.6317Z"
        fill="white"
      />
      <path
        d="M9.31229 25.9726C9.09036 26.5841 9.39462 26.982 9.88562 27.161C10.3766 27.34 10.8664 27.2308 11.0901 26.6193C11.3121 26.0078 10.9768 24.1661 10.9768 24.1661C10.9768 24.1661 9.53482 25.3611 9.31289 25.9726H9.31229Z"
        fill="white"
      />
      <path
        d="M14.2401 25.9726C14.0176 26.5841 14.3224 26.982 14.8134 27.161C15.3044 27.34 15.7942 27.2308 16.0179 26.6193C16.2399 26.0078 15.9046 24.1661 15.9046 24.1661C15.9046 24.1661 14.4626 25.3611 14.2407 25.9726H14.2401Z"
        fill="white"
      />
      <path
        d="M19.1678 25.9726C18.9453 26.5841 19.2502 26.982 19.7412 27.161C20.2322 27.34 20.722 27.2308 20.9457 26.6193C21.1676 26.0078 20.8323 24.1661 20.8323 24.1661C20.8323 24.1661 19.3903 25.3611 19.1684 25.9726H19.1678Z"
        fill="white"
      />
      <path
        d="M21.7595 8.84744C21.7124 8.84744 21.6671 8.85281 21.6205 8.8546C21.0973 6.64541 19.1178 5 16.7487 5C14.2597 5 12.1997 6.81604 11.8095 9.19466C11.4987 9.10815 11.1736 9.05864 10.8341 9.05864C9.11054 9.05864 7.67155 10.262 7.30345 11.8728C5.95574 12.4026 5 13.7109 5 15.2465C5 17.2481 6.62214 18.8708 8.62432 18.8708H21.7601C24.5289 18.8708 26.7727 16.627 26.7727 13.8594C26.7727 11.0918 24.5283 8.84684 21.7601 8.84684L21.7595 8.84744Z"
        fill="white"
      />
    </svg>
  );
}
